// extracted by mini-css-extract-plugin
export default {"wrapper":"mc","star":"nc","emptyStar":"oc","filledStar":"pc","filledStarSvg":"qc"};